import React from "react";
import { Box } from "@mui/material";
import i18n from "../../i18n";
import { H6 } from "../../components/typography";
import { COLORS } from "../../theme";
import {imgContinue} from "../../assets/images/continue";


const QuizAnswer = (props) => {

  const handleContinue = () => {
    if (props.handleContinue) props.handleContinue();
  };

  return (
     <Box sx={{
      marginTop: { xs: 10, md: 20 },
    }}>
      <H6 fontWeight="bold" color={COLORS.white} fontFamily="'ATGText-Bold'">
        {i18n.t("correct_answer")}:
      </H6>
      <H6 color={COLORS.white}  fontWeight={100} marginTop={'0 !important'}>{props.answer} {props.quiz.unit}</H6>

      <Box
        component="img"
        sx={{
          height: { xs: 50, md: 75 },
          width: { xs: 180, md: 270 },
        }}
        alt="continue button"
        src={`${imgContinue}`}
        onClick={handleContinue}
      />
    </Box>
  );
};

export default QuizAnswer;
